// extracted by mini-css-extract-plugin
module.exports = {"campaignItem":"campaignItem_campaignItem__kC7TK","banner":"campaignItem_banner__1UU0f","title":"campaignItem_title__2GEY_"};